import { useState, useCallback, useMemo } from 'react';
import { PartDetailsAndSchematicResponse } from 'types/parts-diagram';

interface UsePartsNavigationProps {
  partsDetails: PartDetailsAndSchematicResponse | null;
  isMultiplePartDiagrams?: boolean;
}

export const usePartsNavigation = ({
  partsDetails,
  isMultiplePartDiagrams
}: UsePartsNavigationProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const graphics = useMemo(
    () => partsDetails?.graphics || [],
    [partsDetails?.graphics]
  );
  const totalImages = graphics.length;
  const shouldShowNavigation = isMultiplePartDiagrams && totalImages > 1;

  const handlePrevious = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalImages - 1 : prevIndex - 1
    );
  }, [totalImages]);

  const handleNext = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === totalImages - 1 ? 0 : prevIndex + 1
    );
  }, [totalImages]);

  const currentGraphic = useMemo(
    () => graphics[currentIndex] || null,
    [graphics, currentIndex]
  );

  return {
    currentIndex,
    totalImages,
    shouldShowNavigation,
    handlePrevious,
    handleNext,
    currentGraphic
  };
};
